import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'
import { mobileCSS, tabletCSS, desktopCSS } from '@measures/responsive'
import SvgIcon from '@components/SvgIcon'
import translate from '@i18n'

interface FooterExpandBarProps {
  isExpanded: boolean
  toggleExpand: () => void
}

type StyledFooterExpandBarProps = Pick<FooterExpandBarProps, 'isExpanded'>

const StyledFooterExpandBar = styled.button<StyledFooterExpandBarProps>`
  ${({
    theme: {
      colors: {
        grey: { grey_10 },
      },
    },
    isExpanded,
  }) => css`
    width: 100%;
    display: block;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 0;
    background-color: ${grey_10};
    padding: 0;
    margin-bottom: ${isExpanded ? 0 : '60px'};
    cursor: pointer;
  `}
`

const StyledFooterExpandBarContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  align-items: center;
  justify-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  min-height: 48px;

  ${desktopCSS(css`
    padding: 0 60px;
  `)}

  ${tabletCSS(css`
    padding: 0 60px;
  `)}

  ${mobileCSS(css`
    padding: 0 12px;
  `)}
`

const StyledFooterExpandBarText = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_80 },
      },
    },
  }) => css`
    display: inline-block;
    font-family: ${sourceSansPro};
    font-size: 16px;
    line-height: 48px;
    font-weight: bold;
    color: ${grey_80};
  `}
`

const FooterExpandBar: FunctionComponent<FooterExpandBarProps> = ({
  isExpanded,
  toggleExpand,
}) => {
  const theme = useTheme()
  const iconName = isExpanded ? 'arrow-up' : 'arrow-down'
  const iconColor = theme.colors.grey.grey_80

  return (
    <StyledFooterExpandBar isExpanded={isExpanded} onClick={toggleExpand}>
      <StyledFooterExpandBarContentWrapper>
        <StyledFooterExpandBarText>
          {translate('footer.ringierFooterTitle')}
        </StyledFooterExpandBarText>
        <SvgIcon iconName={iconName} size={26} color={iconColor} />
      </StyledFooterExpandBarContentWrapper>
    </StyledFooterExpandBar>
  )
}

export default FooterExpandBar
